// @ts-nocheck
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
import { ChildFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { TabDefinition } from "@insite/client-framework/Types/TabDefinition";
import { buildResponsiveFields } from "@store/Framework/Common/Utilities/FieldDefinitionBuilder/buildResponsiveFields";
import { withTab } from "@store/Framework/Common/Utilities/FieldDefinitionBuilder/fieldDefinitionBuilder";

type ResponsiveOptionsType<T> = {
    [K in keyof T as `${string & K}ResponsiveOptions`]: boolean;
};

export type WithResponsiveFields<T extends Record<string, any>, Names extends string> = T & { [K in Names]: T } & {
    [K in Names as `responsive${Capitalize<K>}Fields`]: Array<{ fields: T }>;
} & { [K in Names as `responsive${Capitalize<K>}FieldsResponsiveOptions`]: boolean };

export type WithResponsiveOptions<T> = T & ResponsiveOptionsType<T>;

export type ResponsiveTabConfig = {
    name: string;
    tab: TabDefinition;
    fields: FoundationFieldDefinition[];
};

export function createResponsiveFieldDefinitions(tabs: ResponsiveTabConfig[]): FoundationFieldDefinition[] {
    return tabs.reduce(
        (acc, { tab, fields, name }) =>
            acc.concat(
                withTab(tab, [
                    ...fields,
                    ...buildResponsiveFields(fields as ChildFieldDefinition[], `responsive${name}Fields`),
                ]),
            ),
        [] as FoundationFieldDefinition[],
    );
}
export function mergeResponsiveFields<T extends Record<string, any>>(
    defaultFields: T,
    responsiveTabs: string[],
    breakpointIndex: number,
): T {
    if (breakpointIndex === 0) {
        return defaultFields;
    }
    let newStyles = { ...defaultFields };
    responsiveTabs.forEach(name => {
        const responsiveTab: Partial<T>[] = defaultFields[name];
        const useResponsiveKey = `${name}ResponsiveOptions`;
        const currentBreakpointStyles = responsiveTab?.[breakpointIndex - 1].fields;
        if (!currentBreakpointStyles) {
            return defaultFields;
        }
        if (defaultFields[useResponsiveKey]) {
            newStyles = {
                ...newStyles,
                ...currentBreakpointStyles,
            };
        }
    });
    return newStyles;
}
